import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useSnackbar } from 'notistack'
import { defaultNotifyBarData } from './defaultNotifyBarData'
import AddBannerBarForm from './AddNotifyBarForm'
import { addNotifybar } from 'app/redux/store/features/notifybars'

const AddNotifyBar = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { enqueueSnackbar } = useSnackbar()

    const [NotifyBarData] = useState({ ...defaultNotifyBarData })
    const [apiCallInProgress, setApiCallInProgress] = useState(false)
    const { loading, error } = useSelector((state) => state.notifybars)

    useEffect(() => {
        if (!apiCallInProgress || loading) return
        setApiCallInProgress(false)
        if (error) handleError(error)
        else {
            enqueueSnackbar('Notify Bar added successfully', {
                variant: 'success',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
            navigate('/settings/configuration/notify-bar')
        }
    }, [loading])

    function handleError(error) {
        if (error.status === '401') {
            navigate('/profile/signout')
        } else if (error.detail) {
            enqueueSnackbar(error.detail, {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
        } else {
            enqueueSnackbar(error, {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
        }
    }

    const onAddNotifyBar = async () => {
        setApiCallInProgress(true)
        dispatch(addNotifybar({ ...NotifyBarData }))
    }
    return (
        <React.Fragment>
            <AddBannerBarForm NotifyBarData={NotifyBarData} addNotify={onAddNotifyBar} />
        </React.Fragment>
    )
}

export default AddNotifyBar
